
import {
  OverlayToggle,
  InputSelector,
} from "components/picture_and_map_browser/overlay_toggle"


const default_selector = {
  close_btn:  ".cell--new-development-buildings--pictures-and-map-browser--tabbed__overlay__btn-close",
  full_btns:  ".cell--new-development-buildings--pictures-and-map-browser--tabbed__btn-make-full-screen",
  overlay:    ".cell--new-development-buildings--pictures-and-map-browser--tabbed__overlay",
}

const Factory = {
  _instance: null as null | OverlayToggle,
  instance(selector?: InputSelector){
    if (this._instance != null) {
      return this._instance
    }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    const merged_selector = Object.assign({}, default_selector, selector)
    return new OverlayToggle(merged_selector)
  },
}

export default Factory
